import React from 'react';
import Box, { BoxProps } from 'ui-box';
import classNames from 'classnames';

export interface ICardProps extends BoxProps<'div'> {
  elevation?: 0 | 1 | 2 | 3;
  interactive?: boolean;
}

export const Card: React.FC<ICardProps> = React.forwardRef(
  ({ elevation = 0, interactive = false, className, style, ...props }, ref) => {
    const elevationClass =
      elevation === 0
        ? false
        : elevation === 1
        ? 'shadow'
        : elevation === 2
        ? 'shadow-lg'
        : 'shadow-xl';

    return (
      <Box
        ref={ref}
        style={style}
        className={classNames(
          'card',
          className,
          elevationClass,
          interactive && 'interactive'
        )}
        {...props}
      />
    );
  }
);
